export function generateHarmonizedColors(): string[] {
  return generateVibrantPalette();
}

function generateVibrantPalette(): string[] {
  const vibrantPalettes = [
    ['#FF0000', '#FF8C00', '#FFD700'],
    ['#1A2980', '#26D0CE', '#20E2D7'],
    ['#134E5E', '#71B280', '#A8E6CF'],
    ['#833AB4', '#FD1D1D', '#FCB045'],
    ['#F12711', '#F5AF19', '#FFB75E'],
    ['#00B4DB', '#0083B0', '#48B1BF'],
    ['#4FACFE', '#00F2FE', '#A8EDEA'],
    ['#FF00FF', '#00FFFF', '#00FF00'],
    ['#283048', '#859398', '#BBD2C5'],
    ['#FFB88C', '#DE6262', '#FFB88C']
  ];
  return vibrantPalettes[Math.floor(Math.random() * vibrantPalettes.length)];
}